import {
  filterOption,
  FormField,
  FormInput,
  FormSelect,
  OptionType,
} from '@atlas-frontend/sdk';
import styled from 'styled-components';
import { useWatch } from 'react-hook-form';
import { BUSINESS_LOG_STATUS_VALUES, isStatusField } from './utils';
import translations from './LogDataAttributeSection.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { addTranslations, useTranslation } = i18nNsFactory(
  'log-data-attribute-section'
);
addTranslations(translations);

export interface LogDataAttributeSectionProps {
  id: string;
  index: number;
  options: OptionType[];
}

export function LogDataAttributeSection({
  id,
  index,
  options,
}: LogDataAttributeSectionProps) {
  const { t } = useTranslation();
  const attrFieldName = `${id}.${index}.attribute`;
  const valueFieldName = `${id}.${index}.value`;
  const attribute = useWatch({ name: attrFieldName });

  return (
    <AttributeWrapper>
      <FormField name={attrFieldName} label={t('field.key.label')} size="small">
        <FormSelect
          allowClear={true}
          autoFocus={index === 0}
          className={attrFieldName.replace(/\./g, '-')}
          filterOption={filterOption}
          name={attrFieldName}
          options={options}
          showSearch
        />
      </FormField>
      <FormField
        name={valueFieldName}
        label={t('field.value.label')}
        size="small"
      >
        {isStatusField(id, attribute) ? (
          <FormSelect
            allowClear={true}
            name={valueFieldName}
            options={BUSINESS_LOG_STATUS_VALUES}
          />
        ) : (
          <FormInput name={valueFieldName} />
        )}
      </FormField>
    </AttributeWrapper>
  );
}

const AttributeWrapper = styled.div`
  align-items: center;
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(200px, 1fr) minmax(200px, 1fr);
`;
